import React, {useState, useEffect, Fragment} from 'react';
import {useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';

import {selectSnackbar} from './snackbarSlice';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return (
    <MuiAlert style={{width: 500}} elevation={6} variant="filled" {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },

  close: {
    padding: theme.spacing(0.5),
  },
  snack: {width: 500},
  error: {
    color: ' #fff',
    fontWeight: 500,
    backgroundColor: '#f44336',
    width: 500,
  },
  info: {width: 500},
  success: {
    color: ' #fff',
    fontWeight: 500,
    // backgroundColor: '#42494E',
    width: 500,
  },
}));

export default function CustomSnackbar() {
  const {type, message, snackbar} = useSelector(selectSnackbar);
  const [open, setOpen] = React.useState(false);
  const history = useHistory();
  useEffect(() => {
    if (type === 'error' && message === 'Invalid or expired JWT') {
      localStorage.removeItem('coreUser');
      localStorage.removeItem('coreToken');
      // history.push('/signin');
      setOpen(false);

    }
  }, [type, message]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    // setSnackPack((prev) => [
    //   ...prev,
    //   {message: snackbar.message, key: new Date().getTime()},
    // ]);
    if (type !== '') {
      setOpen(true);
    }
  }, [snackbar]);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={60000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        className={classes.snack}
      >
        <Alert onClose={handleClose} severity={snackbar.type}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
